import auth from "../store/modules/auth";

const haveAccess = (item, router) => {
  if (!item.route) {
    return anyHaveAccess(item.menu, router);
  }

  const route = router.resolve(item.route);

  if (route && !route.route.meta.requiresAuth) {
    return true;
  }

  if (route.route.meta.requiresAuth === true && auth.state.isAuth) {
    return true;
  }

  return route.route.meta.requiresAuth.some(role => {
    return auth.state.user.roles.indexOf(role) != -1;
  });
};

const anyHaveAccess = (items, router) => {
  if (!Array.isArray(items)) {
    return true;
  }

  return items.some(item => haveAccess(item, router));
};

export default {
  anyHaveAccess,
  haveAccess
};
